import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPathFromName } from '@util/path';
import { Page } from '@model/common';
import { HelpCentreSearch } from './HelpCentreSearch';
import { AlgoliaState } from '@model/state/algolia-state';
import { HelpArticleResult } from '@model/search';
import { performNavigate } from '@state/slices/app';
import { getAlgoliaState } from '@state/slices/algolia/algoliaSelectors';
import { setHelpArticlesQuery } from '@state/slices/algolia/algoliaSlice';
import { sentryException } from '@util/sentry';

export const HelpCentreSearchContainer = () => {
  const dispatch = useDispatch();
  const helpArticlesState: AlgoliaState = useSelector(getAlgoliaState);
  const [active, setActive] = useState<boolean>(false);
  const [selectedValue, setSelectedValue] = useState<HelpArticleResult | null>(null);

  const {
    helpArticles: { query, data }
  } = helpArticlesState;

  const handleOnBlur = () => {
    if (active) {
      setActive(false);
    }
  };
  const handleOnFocus = () => {
    setActive(true);
  };
  const handleOnInputChange = (value: string) => {
    dispatch(setHelpArticlesQuery(value));
  };
  const handleOnChange = (value: HelpArticleResult) => {
    setSelectedValue(value);
    if (value) {
      setActive(false);
      const { title, categoryTitle } = value;
      if (title && categoryTitle) {
        dispatch(performNavigate(`${Page.HELP_CENTRE}/${getPathFromName(categoryTitle)}/${getPathFromName(title)}`));
      } else {
        sentryException(
          `Selected help article result without valid path; id=${value.id}; category="${categoryTitle}"; article="${title}"; search="${query}"`
        );
      }
    }
  };

  return (
    <HelpCentreSearch
      onInputChange={handleOnInputChange}
      onChange={handleOnChange}
      value={query}
      selectedValue={active ? null : selectedValue}
      options={data}
      active={active}
      onFocus={handleOnFocus}
      onBlur={handleOnBlur}
    />
  );
};
